import { useAppSelector } from "store";
import styled from "@emotion/styled";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Form, message, Modal } from "antd";
import React, { useState } from "react";
import SettingBoxFormAdd from "./SettingBoxFormAdd";
import { useCreateMasterBox } from "hooks/useMasterData";
import { CreateMasterBoxRequest } from "services/interface";


interface ModalAddProps {
  buttonStyle?: React.CSSProperties;
}

const ModalAdd: React.FC<ModalAddProps> = ({ buttonStyle }) => {

  const queryClient = useQueryClient();

  const contact = useAppSelector((state) => state.auth.contact);

  const { mutate, isPending } = useCreateMasterBox();


  const [showModal, setShowModal] = useState<boolean>(false);

  const [formModal] = Form.useForm();

  const onCloseModal = () => {
    setShowModal(false);
    formModal.resetFields();
  };

  const onFinishModal = (values: any) => {
    console.log('➕ [ModalAdd Component] onFinishModal called with values:', values);
    
    const requestData: CreateMasterBoxRequest = {
      name: values.name,
      description: values.description,
      width: values.width,
      height: values.height,
      length: values.length,
      weight: values.weight,
    };
    
    console.log('➕ [ModalAdd Component] requestData:', requestData);

    mutate(requestData, {
      onSuccess: async (data) => {
        console.log('➕ [ModalAdd Component] onSuccess response:', data);
        console.log('➕ [ModalAdd Component] data keys:', Object.keys(data));
        console.log('➕ [ModalAdd Component] data.success:', data.success);
        console.log('➕ [ModalAdd Component] data.status:', (data as any).status);
        console.log('➕ [ModalAdd Component] data.error_message:', (data as any).error_message);
        console.log('➕ [ModalAdd Component] typeof data.success:', typeof data.success);
        
        // Check multiple possible success indicators
        const isSuccess = data.success === true || 
                         (data as any).status === 'success' || 
                         (data as any).status === 200 ||
                         (!(data as any).error_message && data.data);
        
        console.log('➕ [ModalAdd Component] isSuccess:', isSuccess);
        
        if (isSuccess) {
          await queryClient.refetchQueries({
            queryKey: ["masterBoxes"],
            type: "active",
          });
          onCloseModal();
          message.success("เพิ่มกล่องสำเร็จ");
          formModal.resetFields();
        } else {
          console.log('➕ [ModalAdd Component] Success is false, showing error');
          message.error("เพิ่มกล่องไม่สำเร็จ");
        }
      },
      onError: (error) => {
        console.log('➕ [ModalAdd Component] onError:', error);
        message.error(`เพิ่มกล่องไม่สำเร็จ: ${error.message}`);
      }
    });
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setShowModal(true);
        }}
        disabled={isPending}
        style={buttonStyle}
      >
       เพิ่มกล่อง
      </Button>
      <Modal
        title="เพิ่มกล่อง"
        open={showModal}
        maskClosable={false}
        onCancel={() => {
          onCloseModal();
        }}
        width={window.innerWidth <= 768 ? '95%' : 600}
        style={{ top: 20 }}
        footer={null}
      >
        <WrapperAll>
          <SettingBoxFormAdd form={formModal} onFinish={onFinishModal} isPending={isPending} onClose={onCloseModal} />
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default ModalAdd;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
